export const columnsMonitorinExcel = (t) => [
    { Header: t("table.status"), accessor: "newStatus" },
    { Header: t("table.id"), accessor: "id" },
    { Header: t("table.operator"), accessor: "operatorName" },
    { Header: t("table.typeUnit"), accessor: "tipoUnidad" },
    { Header: t("table.unit"), accessor: "plateNumber" },
    { Header: t("table.origin"), accessor: "origen" },
    { Header: t("table.destinations"), accessor: "destinationNumber" },
    { Header: t("table.dateStart"), accessor: "dateRealInit" },
    { Header: t("table.actualStartDate"), accessor: "realStartTrip" },
    { Header: t("table.actualEndDate"), accessor: "realEndTrip" },
];

export const columnsAppoinmentHistoryExcel = (t) => [
    { Header: t("table.status"), accessor: "newStatus" },
    { Header: t("table.id"), accessor: "idTrip" },
    { Header: t("table.idAppointment"), accessor: "idAppointment" },
    { Header: t("table.operator"), accessor: "operator" },
    { Header: t("table.typeUnit"), accessor: "unitType" },
    { Header: t("table.destinations"), accessor: "shipTo" },
    { Header: t("table.costCenter"), accessor: "costCenter" },
    { Header: t("table.state"), accessor: "state" },
    { Header: t("table.municipality"), accessor: "town" },
    { Header: t("table.collectionDate"), accessor: "newCollectionDate" },
    { Header: t("table.arrival"), accessor: "arrival" },
    { Header: t("table.start"), accessor: "start" },
    { Header: t("table.endOfCollection"), accessor: "collectionEnd" },
    { Header: t("table.serviceDuration"), accessor: "lengthService" },
    { Header: t("table.evidenceArrived"), accessor: "evidenceEnd" },
    { Header: t("table.collectedBags"), accessor: "collectedBags" },
    { Header: t("table.endEvidence"), accessor: "evidenceEnd" },
    { Header: t("table.incidents"), accessor: "incidents" },
];

export const columnsCostReportExcel = (t) => [
    { Header: t("costReport.invoiceNumber"), accessor: "invoiceNumber" },
    { Header: t("costReport.storeCostcenter"), accessor: "storeCostcenter" },
    { Header: t("costReport.storeName"), accessor: "storeName" },
    { Header: t("costReport.company"), accessor: "company" },
    { Header: t("costReport.supplierCompanyName"), accessor: "supplierCompanyName" },
    { Header: t("costReport.taxFolio"), accessor: "taxFolio" },
    { Header: t("costReport.invoiceDate"), accessor: "invoiceDate" },
    { Header: t("costReport.subTotal"), accessor: "subTotal" },
    { Header: t("costReport.dayCost"), accessor: "dayCost" },
    { Header: t("costReport.iva"), accessor: "iva" },
    { Header: t("costReport.total"), accessor: "total" },
    { Header: t("costReport.serviceDescription"), accessor: "serviceDescription" },
    { Header: t("costReport.totalDaysWorked"), accessor: "totalDaysWorked" },
    { Header: t("costReport.additionalServices"), accessor: "additionalServices" }
];
